import React from 'react';
import { useTranslation } from 'react-i18next';
import { ExceptionsEditor } from '../components/ExceptionsEditor';
import { WeeklyHoursEditor } from '../components/WeeklyHoursEditor';
import { SchedulingProfile } from '../types';

export const HoursTab: React.FC<{ profile: SchedulingProfile }> = ({ profile }) => {
  const { t } = useTranslation();
  return (
    <div className="max-w-3xl space-y-10">
      <section className="space-y-3">
        <div>
          <h3 className="text-base font-semibold text-gray-900 dark:text-white">
            {t('schedulingAdmin.hours.title')}
          </h3>
          <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
            {t('schedulingAdmin.hours.intro')}
          </p>
        </div>
        <WeeklyHoursEditor owner="profile" ownerId={profile.id} />
      </section>

      <section className="space-y-3">
        <div>
          <h3 className="text-base font-semibold text-gray-900 dark:text-white">
            {t('schedulingAdmin.exceptions.title')}
          </h3>
          <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
            {t('schedulingAdmin.exceptions.introProfile')}
          </p>
        </div>
        <ExceptionsEditor owner="profile" ownerId={profile.id} />
      </section>
    </div>
  );
};
